export default __webpack_public_path__ + "static/media/GS8000.00945dbb.png";